<template>
  <div>
    <div class="container">
      <el-page-header class="page-header" @back="goBack" content="自拟组方"></el-page-header>
      <el-form label-width="120px" label-position="right" style="margin-top: 40px;">
        <el-form-item label="*诊断结果：" class="form-item">
          <el-input v-model="diagnoseResult" type="text" placeholder="请输入诊断信息" clearable></el-input>
        </el-form-item>
        <el-form-item label="*服药时间：" class="form-item">
          <el-radio-group class="radio-group" v-model="takeMedTime">
            <el-radio-button class="radio-button" label="饭前服用" border>饭前服用</el-radio-button>
            <el-radio-button class="radio-button" label="饭后服用" border>饭后服用</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item label="*开始日期：" class="form-item">
          <el-date-picker class="dialog-picker" v-model="startDate" placeholder="请选择开始日期" format="yyyy-MM-dd"
            value-format="yyyy-MM-dd" @change="startDateChange" type="date" size="large" prefix-icon="clear">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="*结束日期：" class="form-item">
          <el-date-picker class="dialog-picker" v-model="endDate" placeholder="请选择结束日期" format="yyyy-MM-dd"
            value-format="yyyy-MM-dd" @change="endDateChange" type="date" size="large" prefix-icon="clear">
          </el-date-picker>
        </el-form-item> -->
      </el-form>
      <el-card style="margin-top: 30px;">
        <div style="display: flex;flex-direction: row;margin-top: 20px;align-items: center;">
          <span style="margin-left: 22px;margin-right: 20px;">*开方:</span>
          <el-select v-model="selectDrug" filterable :filter-method="customFilter" placeholder="请选择药品" style="width: 300px;">
            <el-option v-for="item in drugList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-input v-model="weight" type="number" placeholder="重量(g)" style="width: 120px;margin-left: 50px;"></el-input>
          <el-button type="primary" style="width: 150px;margin-left: 100px;" @click="addDrug">添加</el-button>
        </div>
        <span style="display: flex;flex-direction: row;color: #999999;font-size: 14px;margin-left: 85px;margin-top: 4px;">可用汉字或拼音首字母搜索。</span>
        <div style="width: 100%;height: 1px;background-color: #ececec;margin-top: 20px;margin-bottom: 20px;"></div>
        <el-table :data="selectDrugList" :span-method="arraySpanMethod" style="width:97%; padding-left: 2%;":row-class-name="tableRowClassName">
          <el-table-column prop="index" label="序号" width="180">
          </el-table-column>
          <el-table-column prop="label" label="药品名称" width="180">
          </el-table-column>
          <el-table-column prop="weight" label="重量(g)">
            <template slot-scope="scope">
              <el-input v-model="scope.row.weight" type="number" style="width: 120px;" placeholder="重量(g)" @input="((val)=>{numberChange(val, scope.$index)})" @keyup.native.enter></el-input>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="deleteClick(scope.row)" v-show="scope.$index != selectDrugList.length-1">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
        </div>
    <el-button style="width: 384px;border-radius: 40px;margin-top: 60px;margin-bottom: 60px;font-size: 18px;height: 45px;" type="primary" @click="confirm">自拟组方确认</el-button>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        allDrugList: [],
        drugList: [],
        selectDrugList: [],
        selectDrug: '',
        weight: '',
        diagnoseResult: '',
        takeMedTime: "",
        startDate: '',
        endDate: ''
      };
    },
    mounted() {
      this.submitData = JSON.parse(sessionStorage.getItem("submitData"))
      var drugList = JSON.parse(sessionStorage.getItem('selectDrugList'))
      if(drugList && drugList != null && drugList != undefined && drugList != ""){
        this.selectDrugList = drugList
      }
      var handMakeInfo = JSON.parse(sessionStorage.getItem('handMakeInfo'))
      if(handMakeInfo){
        this.diagnoseResult = handMakeInfo.diagnoseResult
        this.takeMedTime = handMakeInfo.takeMedTime
      }
      this.getDrugList()
    },
    methods: {
      goBack() {
        this.$router.go(-1)
      },
      arraySpanMethod({ row, column, rowIndex, columnIndex }) {
        if (rowIndex == this.selectDrugList.length-1 && columnIndex == 0) {
          return [1, 4];
        }
      },
      numberChange(value,index){
        this.selectDrugList[index].weight = value
        var totalWeight = 0
        this.selectDrugList.forEach((item) => totalWeight += (item.weight.length>0?Number.parseInt(item.weight):0))
        var drug = this.selectDrugList.find((item) => item.value == -1)
        if(drug){
          drug.index = "总计："+(this.selectDrugList.length-1)+"味，"+totalWeight+"克；"
        }
        console.log(value)
      },
      tableRowClassName({row, rowIndex}) {
        if (rowIndex == this.selectDrugList.length - 1) {
          return 'total-row';
        }
        return '';
      },
      startDateChange(val) {
        var flag = this.utils.afterDateFromCurrent(val)
        setTimeout(() => {
          if (!flag) {
            this.startDate = ''
            this.$message({
              message: '开始日期必须大于当前日期',
              type: 'warning'
            })
          }
        }, 100)
      },
      endDateChange(val) {
        var flag = this.utils.afterDateFromCurrent(val)
        setTimeout(() => {
          if (!flag) {
            this.endDate = ''
            this.$message({
              message: '结束日期必须大于当前日期',
              type: 'warning'
            })
          }
        }, 100)
      },
      customFilter(value){
        if (value) { //val存在
          this.drugList = this.allDrugList.filter((item) => {
            if (!!~item.label.indexOf(value) || !!~item.pinYin.toUpperCase().indexOf(value.toUpperCase())) {
              return true
            }
          })
          console.log("过滤回调1："+value)
        } else { //val为空时，还原数组
          this.drugList = this.allDrugList;
          console.log("过滤回调2："+value)
        }
      },
      getDrugList() {
        this.wjtHttp.get(this, '/api/medicine/list', {}, true, (res) => {
          var data = res.data
          if (data.code == 200) {
            var list = data.data
            for (var i = 0; i < list.length; i++) {
              var netDrug = list[i]
              var drug = {
                value: netDrug.medicineId,
                label: netDrug.medicineName,
                pinYin: netDrug.pinyinInitialName,
                weight: 0
              }
              this.drugList.push(drug)
              this.allDrugList.push(drug)
            }
          } else {
            this.$message({
              message: (data.msg && data.msg.length > 0) ? data.msg : '获取中草药形态异常',
              type: 'error'
            })
          }
        }, (err) => {
          console.log(err)
        })

      },
      addDrug() {
        if (this.selectDrug.length == 0) {
          this.$message("请选择一个药品")
          return
        }
        if (this.weight == 0) {
          this.$message("请输入药品重量")
          return
        }
        const pattern = /^[1-9]\d*$/;
        if(!pattern.test(this.weight)){
          this.$message("药品重量必须是大于0的整数")
          return
        }
        var drug = this.selectDrugList.find((item) => item.value == this.selectDrug)
        if (drug != null) {
          this.$message("不能选择同一个药品")
          return
        }

        var drug = this.drugList.find((item) => item.value == this.selectDrug)
        drug.weight = this.weight
        drug.index = this.selectDrugList.length == 0?1:this.selectDrugList.length
        this.selectDrugList.splice(this.selectDrugList.length-1,0,drug)
        this.selectDrug = ''
        this.drugList = this.allDrugList
        this.weight = ''
        var totalWeight = 0
        this.selectDrugList.forEach((item) => totalWeight += (item.weight.length>0?Number.parseInt(item.weight):0))
        if(this.selectDrugList.length == 1){
          this.selectDrugList.push({
            value:-1,
            label:'',
            weight:'0',
            index:"总计："+drug.index+"味，"+totalWeight+"克；"
            })
        }else{
          this.selectDrugList[this.selectDrugList.length-1].index = "总计："+drug.index+"味，"+totalWeight+"克；"
        }
        console.log(this.selectDrugList)
      },
      deleteClick(drug) {
        this.selectDrugList.splice(this.selectDrugList.findIndex((item) => item.value == drug.value), 1)
        this.selectDrugList.forEach((item,index) =>{
          item.index = index+1
        })
        if(this.selectDrugList.length == 1){
          this.selectDrugList.pop()
        }else{
          var totalWeight = 0
          this.selectDrugList.forEach((item) => totalWeight += (item.weight.length>0?Number.parseInt(item.weight):0))
          this.selectDrugList[this.selectDrugList.length-1].index = "总计："+(this.selectDrugList.length-1)+"味，"+totalWeight+"克；"
        }
      },
      confirm(){
        if(this.diagnoseResult.length == 0){
          this.$message("请输入诊断结果")
          return
        }
        if(this.takeMedTime.length == 0){
          this.$message("请选择服药时间")
          return
        }
        if(this.selectDrugList.length == 0){
          this.$message("请添加药方")
          return
        }
        var drug
        this.selectDrugList.forEach((item,index) =>{
          if(index != this.selectDrugList.length-1 && (item.weight <= 0 || item.weight == "")){
            drug = item
          }
        })
        if(drug){
          this.$message(drug.label+"的重量必须是大于0的整数")
          return
        }
        sessionStorage.setItem('selectDrugList',JSON.stringify(this.selectDrugList))
        sessionStorage.setItem('handMakeInfo',JSON.stringify({
          diagnoseResult:this.diagnoseResult,
          takeMedTime:this.takeMedTime
        }))
        this.$router.push('/handmadePrescriptionConfirm')
      },
      generateTableData(prescriptions){
        var tablePrescription = []
        for (var i = 0; i < prescriptions.length; i++){
          var table_data_item = {}
          var item = prescriptions[i]
          table_data_item.count = item.count
          table_data_item.charge = item.charge
          table_data_item.totalWeight = item.totalWeight
          table_data_item.startDate = item.startDate
          table_data_item.endDate = item.endDate
          table_data_item.title = item.name
          table_data_item.takeTime = item.takeTime
          table_data_item.disease = item.disease
          var itemArray = item.prescription
          for (var j = 0; j < item.prescription.length;j++){
              var itemJ = item.prescription[j]
              if(j%2 == 1){
                  itemArray[j-1].key1 = itemJ.key
                  itemArray[j-1].value1 = itemJ.value
                  itemArray[j-1].index1 = itemJ.index
                  itemArray[j-1].visible1 = false
              }else{
                itemArray[j].visible = false
              }
          }
          var options = []
          for (var k = 0; k < itemArray.length;k++){
              if(k%2 == 0){
                  options.push(itemArray[k])
              }
          }
          table_data_item.options = options
          tablePrescription.push(table_data_item)
        }
        return tablePrescription
      },
    }
  };
</script>

<style scoped>
  .container {
    width: 1160px;
    margin: auto auto;
  }

  .page-header {
    width: 1080px;
    margin-top: 30px;
    color: #333333;
    font-size: 20px;
  }
  .el-table .total-row {
      background: oldlace;
      font-size: 40px;
      color: #333333;
    }
  .form-item{
    margin-top: 30px;
  }
  .page-header>>>div {
    color: #333333;
    font-size: 20px;
  }

  .area-header-one {
    margin-top: 35px;
  }
</style>



// WEBPACK FOOTER //
// src/components/kaifang/handmadePrescription.vue